import { object, string } from 'yup';
import type { TFunction } from 'i18next';

export const joinUsSchema = (t: TFunction) =>
	object({
		name: string(),
		email: string().email(t('Invalid email format')).required(t('Email is required')),
	});
